let countries = {
        "AU": "Australia",
        "AD": "Andorra",
        "AE": "UAE",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AL": "Albania",
        "AM": "Armenia",
        "AO": "Angola",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CD": "Central African Republic",
        "CF": "Central African Republic",
        "CG": "Republic of the Congo",
        "CH": "Switzerland",
        "CI": "Cote d'Ivoire",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "GP": "Guadeloupe",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FA": "Iran",
        "FI": "Finland",
        "FJ": "Fiji",
        "FM": "Federated States of Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GD": "Grenada",
        "GE": "Georgia",
        "GH": "Ghana",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GF": "French Guiana",
        "GY": "Guyana",
        "GI": "Gibraltar",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Republic of Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IN": "India",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "DPRK",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxemburg",
        "LV": "Latvia",
        "LY": "Libya",
        "MQ": "Martinique",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldavia",
        "ME": "Montenegro",
        "MG": "Madagascar",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MR": "Mauritania",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NZ": "New Zealand",
        "OM": "Oman",
        "OS": "South Ossetia",
        "PA": "Panama",
        "PE": "Peru",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SI": "Slovenia",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Republic of Suriname",
        "ST": "Sao Tome and Principe",
        "SV": "Salvador",
        "SW": "Swahili",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TD": ("Chad"),
        "TG": ("Togo"),
        "TH": "Thailand",
        "TJ": "Tadjikistan",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TC": "Turks and Caicos Islands",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "GB": "United Kingdom",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "United States Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WS": "Samoa",
        "YE": "Yemen",
        "ZA": "Republic of South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    iso2Wrapped = [],
    iso2ToIso3 = {
        AX: "ALA",
        AF: "AFG",
        AL: "ALB",
        DZ: "DZA",
        "PT-BR": "BRA", // for showing the flag of Brazil in case of PT-BR and preventing the error when clicking on Join button
        AS: "ASM",
        AD: "AND",
        AO: "AGO",
        AI: "AIA",
        AQ: "ATA",
        AG: "ATG",
        AR: "ARG",
        AM: "ARM",
        AW: "ABW",
        AU: "AUS",
        AT: "AUT",
        AZ: "AZE",
        BS: "BHS",
        BH: "BHR",
        BD: "BGD",
        BB: "BRB",
        BY: "BLR",
        BE: "BEL",
        BZ: "BLZ",
        BJ: "BEN",
        BM: "BMU",
        BT: "BTN",
        BO: "BOL",
        BA: "BIH",
        BW: "BWA",
        BV: "BVT",
        BR: "BRA",
        IO: "IOT",
        BN: "BRN",
        BG: "BGR",
        BF: "BFA",
        BI: "BDI",
        KH: "KHM",
        CM: "CMR",
        CA: "CAN",
        CV: "CPV",
        KY: "CYM",
        CF: "CAF",
        TD: "TCD",
        CL: "CHL",
        CN: "CHN",
        CX: "CXR",
        CC: "CCK",
        CO: "COL",
        KM: "COM",
        CD: "COD",
        CG: "COG",
        CK: "COK",
        CR: "CRI",
        CI: "CIV",
        HR: "HRV",
        CU: "CUB",
        CY: "CYP",
        CZ: "CZE",
        DK: "DNK",
        DJ: "DJI",
        DM: "DMA",
        DO: "DOM",
        EC: "ECU",
        EG: "EGY",
        EN: "ENG",
        SV: "SLV",
        GQ: "GNQ",
        ER: "ERI",
        EE: "EST",
        ET: "ETH",
        FK: "FLK",
        FO: "FRO",
        FJ: "FJI",
        FI: "FIN",
        FR: "FRE", // FRA
        FA: "FAS",
        GF: "GUF",
        PF: "PYF",
        TF: "ATF",
        GA: "GAB",
        GM: "GMB",
        GE: "GEO",
        DE: "GER", //"DEU"
        GH: "GHA",
        GI: "GIB",
        GR: "GRC",
        GL: "GRL",
        GD: "GRD",
        GP: "GLP",
        GU: "GUM",
        GT: "GTM",
        GN: "GIN",
        GW: "GNB",
        GY: "GUY",
        HT: "HTI",
        HM: "HMD",
        HN: "HND",
        HK: "HKG",
        HU: "HUN",
        HY: "ARM",
        IS: "ISL",
        IN: "IND",
        ID: "IDN",
        IR: "IRN",
        IQ: "IRQ",
        IE: "IRL",
        IL: "ISR",
        HE: "HEB", //IL/ISR
        IT: "ITA",
        JM: "JAM",
        JP: "JPN",
        JO: "JOR",
        KZ: "KAZ",
        KE: "KEN",
        KI: "KIR",
        KP: "PRK",
        KA: "GEO",
        KR: "KOR",
        KO: "KOR",
        KW: "KWT",
        KG: "KGZ",
        LA: "LAO",
        LV: "LVA",
        LB: "LBN",
        LS: "LSO",
        LR: "LBR",
        LY: "LBY",
        LI: "LIE",
        LT: "LTU",
        LU: "LUX",
        MO: "MAC",
        MK: "MKD",
        MG: "MDG",
        MW: "MWI",
        MY: "MYS",
        MV: "MDV",
        ML: "MLI",
        MT: "MLT",
        MH: "MHL",
        MQ: "MTQ",
        MR: "MRT",
        MU: "MUS",
        YT: "MYT",
        MX: "MEX",
        FM: "FSM",
        MD: "MDA",
        MC: "MCO",
        MN: "MNG",
        MS: "MSR",
        MA: "MAR",
        MZ: "MOZ",
        MM: "MMR",
        NA: "NAM",
        NR: "NRU",
        NP: "NPL",
        NL: "NLD",
        AN: "ANT",
        NC: "NCL",
        NZ: "NZL",
        NI: "NIC",
        NE: "NER",
        NG: "NGA",
        NU: "NIU",
        NF: "NFK",
        MP: "MNP",
        NO: "NOR",
        OM: "OMN",
        OS: "RSO",
        PK: "PAK",
        PW: "PLW",
        PS: "PSE",
        PA: "PAN",
        PG: "PNG",
        PY: "PRY",
        PE: "PER",
        PH: "PHL",
        PN: "PCN",
        PL: "POL",
        PT: "POR", //"PRT",
        PR: "PRI",
        QA: "QAT",
        RE: "REU",
        RO: "ROU",
        RU: "RUS",
        RW: "RWA",
        SH: "SHN",
        KN: "KNA",
        LC: "LCA",
        PM: "SPM",
        VC: "VCT",
        WS: "WSM",
        SM: "SMR",
        ST: "STP",
        SA: "SAU",
        SN: "SEN",
        CS: "SCG",
        SC: "SYC",
        SL: "SLE",
        SG: "SGP",
        SK: "SVK",
        SI: "SVN",
        SW: "SW",
        SB: "SLB",
        SO: "SOM",
        ZA: "ZAF",
        GS: "SGS",
        ES: "SPA", //ESP
        LK: "LKA",
        SD: "SDN",
        SR: "SUR",
        SJ: "SJM",
        SZ: "SWZ",
        SE: "SWE",
        CH: "CHE", //"CHE",
        SY: "SYR",
        TW: "TWN",
        TJ: "TJK",
        TZ: "TZA",
        TH: "THA",
        TL: "TLS",
        TG: "TGO",
        TK: "TKL",
        TO: "TON",
        TT: "TTO",
        TN: "TUN",
        TR: "TUR",
        TM: "TKM",
        TC: "TCA",
        TV: "TUV",
        UG: "UGA",
        UA: "UKR",
        AE: "UAE",
        GB: "GBR",
        US: "USA",
        UM: "UMI",
        UY: "URY",
        UZ: "UZB",
        VU: "VUT",
        VA: "VAT",
        VE: "VEN",
        VN: "VNM",
        VG: "VGB",
        VI: "VIR",
        WF: "WLF",
        EH: "ESH",
        YE: "YEM",
        ZH: "ZHH",
        ZM: "ZMB",
        ZW: "ZWE"
    };

for (let country in countries) {
    iso2Wrapped.push({
        iso: country,
        name: countries[country]
    });
}

export default {
    list: iso2Wrapped,
    countries: countries,
    iso2ToIso3
};